<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_15872_11135)">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M4.73578 1.46992C4.73578 0.98115 5.13201 0.584922 5.62078 0.584922L13.3791 0.584923C13.8679 0.584923 14.2641 0.981151 14.2641 1.46992C14.2641 1.9587 13.8679 2.35492 13.3791 2.35492L10.4385 2.35492L10.4385 16.6451L13.3787 16.6451C13.8674 16.6451 14.2637 17.0413 14.2637 17.5301C14.2637 18.0188 13.8674 18.4151 13.3787 18.4151L5.62035 18.4151C5.13158 18.4151 4.73535 18.0188 4.73535 17.5301C4.73535 17.0413 5.13158 16.6451 5.62035 16.6451L8.66848 16.6451L8.66848 2.35492L5.62078 2.35492C5.13201 2.35492 4.73578 1.95869 4.73578 1.46992Z"
      fill="currentColor" />
  </g>
  <defs>
    <clipPath id="clip0_15872_11135">
      <rect width="19" height="19" fill="white" />
    </clipPath>
  </defs>
</svg>